<template>
  <div class="inline-flex relative border border-border rounded pl-6 pr-14 pt-5 pb-5">
    <div class="w-14-2 h-14-2 mr-6">
      <component :is="`icon-file-${iconDisplayed}`"
                 class="text-border-hover"/>
    </div>
    <div>
      <div class="text-text-label text-md mb-2">{{ file.name }}</div>
      <div class="text-sm text-text-muted">{{ humanFileSize(file.size, true) }}</div>
    </div>

    <IconCross @click.native="$emit('remove')"
               class="absolute right-4 top-4 w-4 h-4 text-border hover:text-red transition duration-200 cursor-pointer"/>
  </div>
</template>

<script>
import IconCross from "@/components/icons/IconCross";
import IconFileCsv from "@/components/icons/FileIcons/IconFileCsv";
import IconFileXml from "@/components/icons/FileIcons/IconFileXml";
import IconFileXls from "@/components/icons/FileIcons/IconFileXls";

export default {
  name: "FileDisplay",
  components: {IconFileXls, IconFileXml, IconFileCsv, IconCross},
  props: {
    file: {
      type: File,
      required: true
    }
  },
  computed:{
    iconDisplayed() {
      let ext = this.file.name.split('.').pop();
      switch (ext) {
        case 'xls':
        case 'xlsx':
          return 'xls';
        case 'csv':
          return 'csv';
        case 'xml':
          return 'xml';
      }
    },
  },
  methods: {
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + ' Б';
      }

      const units = si
          ? ['КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЕБ', 'ЗБ', 'ЙБ']
          : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


      return bytes.toFixed(dp) + ' ' + units[u];
    }
  }
}
</script>

<style scoped>

</style>